import { render, staticRenderFns } from "./PushMessage.vue?vue&type=template&id=b0f58f78&scoped=true"
import script from "./PushMessage.vue?vue&type=script&lang=js"
export * from "./PushMessage.vue?vue&type=script&lang=js"
import style0 from "./PushMessage.vue?vue&type=style&index=0&id=b0f58f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f58f78",
  null
  
)

export default component.exports